import axios from "axios";
import { importRevenue } from '../_constants/api.constant'

// None of the split views declare a permission class, so they are deliberately called
// without an Authorization header: knox rejects a stale/expired token during
// authentication and would 401 an endpoint that needs no auth at all.
const request = (promise) => promise.then(function (response) {
    return response;
}).catch(function (error) {
    // handle error
    console.log(error);
    console.log(error.response);
    return error.response;
});

// 202 + a task_id, or 409 when a worker is already on this import.
// The body is only read for the split flag now, any other key is ignored server side.
export async function StartRevenueSplit(importId) {
    return request(axios.put(importRevenue.SPLIT_START + importId + '/', { split: true }));
}

// Poll until split_status is success or failed. The outcome/skipped breakdown is
// only attached once it finishes, so the running polls stay cheap.
export async function GetSplitStatus(importId, params = {}) {
    return request(axios.get(importRevenue.SPLIT_STATUS + importId + '/', { params }));
}

// can_split / in_progress / split_status drive the button, split alone cannot tell
// "not split yet" apart from "a worker is splitting right now".
// The view paginates the rows it inspects, so it answers nothing without limit/offset.
export async function CheckSplit(importId, params = {}) {
    const { limit = 10, offset = 0 } = params;
    return request(axios.get(importRevenue.CHECK_SPLIT + importId + '/', { params: { ...params, limit, offset } }));
}
